// extracted by mini-css-extract-plugin
export default {"itemId":"listItem_itemId__C700v","itemName":"listItem_itemName__1i7ng"};